import Popover from './popover'

/* istanbul ignore next */
Popover.install = function (Vue) {
  Vue.component(Popover.name, Popover)
}

export default Popover
